import React from 'react';
import styled from 'styled-components';
import t from 'prop-types';
import {withRouter} from 'react-router';
import {colors} from '../styles';
import {Bold, Text} from '../atoms/Text';
import SideBarAlarmList from '../molecules/SideBarAlarmList';
import Clear from '@material-ui/icons/Clear';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Button from '@material-ui/core/Button';
import SystemTitle from './SystemTitle';

const SideBarRightMain = styled.div`
  background-color: ${colors.lightGray};
  width: 100%;
  padding: 80px 0 10px;
  display: flex;
  height: 100vh;
  flex-direction: column;
  justify-content: center;
`;

const buttonStyles = `
  height: 40px;
  margin: 10px 40px;
  width: 80%;
  padding: 0 10px;
  text-transform: capitalize;
  border-radius: 4px;
  align-items: center;
  display: flex;
  align-self: flex-end;
  cursor: pointer;
`;

const SideBarButton = styled(Button)`
  ${buttonStyles};
  background-color: ${props => props.theme.colors.primary};
  &:hover {
    background-color: ${props => props.theme.colors.lightBlue};
  }
`;

const SideBarLinkButton = styled.a`
  ${buttonStyles};
  color: inherit;
  text-decoration: none;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    background-color: ${props => props.theme.colors.lightGray};
  }
`;

const SystemOverviewSideBar = ({selected, onCollapse, history}) => {
  const {alarms, id, location} = selected;
  return (
    <SideBarRightMain>
      <div style={{position: 'relative', margin: '0 40px'}}>
        <Bold style={{fontSize: '20px'}}>SELECTED SYSTEM</Bold>
        <div
          style={{
            height: 30,
            width: 30,
            borderRadius: 15,
            position: 'absolute',
            top: -5,
            left: -55,
            backgroundColor: colors.primary,
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
          onClick={onCollapse}
        >
          <Clear style={{color: 'white', cursor: 'pointer'}}/>
        </div>
      </div>
      <div style={{margin: '40px 40px 20px'}}>
        <SystemTitle id={selected.id} positionKnown={Boolean(location && location.longitude && location.latitude)}/>
        {alarms && <div style={{marginTop: '24px'}}><Text>{alarms.length === 0 ? 'No active alarms' : 'Active alarms'}</Text></div>}
      </div>
      <div style={{marginLeft: '15px', paddingLeft: '25px', marginRight: '40px', flex: 1, overflowY: 'auto'}}>
        <SideBarAlarmList alarms={alarms} />
      </div>
      <SideBarLinkButton
        id="gtm-abc-link"
        style={{marginTop: '40px'}}
        href={`https://reports.ampelmann.nl/Reports/report/Operations/Ampelmann_Briefing_Card?Amp=${id}`}
        target="_blank"
      >
        <Text style={{marginTop: '2px'}}>View Ampelmann Briefing Card</Text>
        <ArrowForward style={{marginLeft: 'auto'}}/>
      </SideBarLinkButton>
      <SideBarButton onClick={() => history.push(`system/${selected.id}`)}>
        <Text style={{color: 'white', marginTop: '2px'}}>View System Information</Text>
        <ArrowForward style={{color: 'white', marginLeft: 'auto'}} />
      </SideBarButton>
    </SideBarRightMain>
  );
};

SystemOverviewSideBar.propTypes = {
  selected: t.object,
  onCollapse: t.func,
  history: t.object
};

export default withRouter(SystemOverviewSideBar);

